const spanStyle = { display: 'block', width: '100%' };
const buttonStyle = { height: '100%' };

export { buttonStyle, spanStyle };
